import React from 'react'

import { Description } from 'Components/Blocks'
import { Button, Row } from 'Components/UI'
import { EventItem } from 'Types/emajinAPI'

import { Container } from './styles'

type Props = {
  data?: EventItem
  onRSVP?: () => void
}

function EventBody({ data, onRSVP }: Props) {
  if (!data) return null

  return (
    <Container>
      {data?.description ? (
        <Description value={data.description} />
      ) : (
        'No event description'
      )}

      <Row mt={8}>
        <Button large minWidth={100} onClick={onRSVP}>
          RSVP
        </Button>
      </Row>
    </Container>
  )
}

export default EventBody
